import type { IntlShape } from 'react-intl';

import {
  createColumn,
  getSortOptions,
} from '../../../../shared/utils/tableUtils';
import { managePageMessages } from '../../constants/managepage';

export const getAgentTableColumns = (intl: IntlShape) => [
  createColumn(
    'name',
    intl.formatMessage(managePageMessages.columnKeyName),
    '12rem',
    {
      isPinned: true,
    }
  ),
  createColumn(
    'description',
    intl.formatMessage(managePageMessages.columnKeyDesc),
    '10rem',
    {
      isSortable: false,
    }
  ),
  createColumn(
    'platform',
    intl.formatMessage(managePageMessages.columnKeyPlatform),
    '10rem',
    {
      isSortable: false,
    }
  ),
  createColumn(
    'llmModels',
    intl.formatMessage(managePageMessages.columnKeyLlmModel),
    '10rem',
    {
      isSortable: false,
    }
  ),
  createColumn(
    'status',
    intl.formatMessage(managePageMessages.columnKeyStatus),
    '6rem',
    {
      isSortable: false,
    }
  ),
  createColumn(
    'criticality',
    intl.formatMessage(managePageMessages.columnKeyCriticality),
    '6rem'
  ),
  createColumn(
    'ownerIds',
    intl.formatMessage(managePageMessages.columnKeyBuOwner),
    '10rem',
    {
      isSortable: false,
    }
  ),
  createColumn(
    'createdAt',
    intl.formatMessage(managePageMessages.columnKeyCreatedOn),
    '7.25rem'
  ),
  {
    key: 'actionColumn',
    label: 'actionColumn',
    value: 'actionColumn',
    isChecked: true,
    isPinned: true,
    isColumnConfigEnabled: true,
    width: 'min-content',
  },
];

const sortableColumns = ['name', 'criticality', 'createdAt'];

export const getSortConfigs = (intl: IntlShape) =>
  sortableColumns.map((key) => ({ key, sortOptions: getSortOptions(intl) }));
